export const exterior_view04ImageOptions = {
  angle: 'exterior_view04',
  staticOptions: {
    BowSprit: 1,
    HullTreatment: 1,
    TeakOnSideDecks: 1,
    TeakOnCoachroof: 1,
    SprayHood: 1,
    BiminiForHelmsman: 1,
    BiminiForForwardCockpit: 1,
    CockpitTent: 1,
    Wheel: 1,
    MastAndBoom: 1,
    BoomCover: 1,
    Gangway: 1,
    SolarPanels: 1,
    WheelingSeats: 1,
    Boom: 1
  },
  mattes: [
    {
      option: 'TeakOnSideDecks',
      dependency: 'Deck'
    },
    {
      option: 'Wheel',
      dependency: 'AftBench'
    },
    {
      option: 'Gangway',
      dependency: null
    }
  ]
}



// WEBPACK FOOTER //
// ./src/X56/views/exterior_view04.js